import { DEFAULT_INITIAL_VALUES, expandedConfig } from "./constants";
import type { Config, Values } from "./types";

export const initialValuesBuilder = ({ values, config }: { values: Values; config: Config }) => {
    const { email, firstName, lastName } = values;
    const { withNames, country } = config;

    const names = withNames ? { firstName, lastName } : {};

    const expandedValues = expandedConfig[country] ?? {};

    return { ...DEFAULT_INITIAL_VALUES, ...names, ...expandedValues, email };
};
